import * as React from 'react';
import { Link as RouterLink } from 'react-router-dom';

export type InfoLinkProps = {
	href: string;
	title: string | number;
	text: string;
};

export const InfoLink = ({ href, title, text }: InfoLinkProps) => (
	<RouterLink className="a-info-link" to={href}>
		<span className="a-info-link__title">{title}</span>
		<span className="a-info-link__text">{text}</span>
	</RouterLink>
);

export default InfoLink;
